// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e os
// carregadores das telas. Outro módulo usa a `public.ts` (A06).
export { SPI_CONSULT_PATH, SPI_PATH, spiConsultScreen, spiPanelScreen } from './spi.screen';
export { spiConsultSearch, spiPanelSearch } from './spi.search';
export { loadSpiMessages } from './spi.catalog';

/** A tela do painel (`SpiPanelRouteScreen`), por `lazyScreen`. */
export const loadSpiPanelScreen = () => import('./spi.page');

/** A tela da consulta (`SpiConsultRouteScreen`), por `lazyScreen`. */
export const loadSpiConsultScreen = () => import('./spi-consult.page');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadSpiGuides = () => import('./spi.guide');
